
import { Component, Vue, Watch } from "vue-property-decorator";
import { searchCustomer } from "@/api/customer";
import { listProcessStages } from "@/api/booking-order";
import Pagination from "@/components/Pagination/index.vue";
import {
  getInvoiceSearch,
  downloadAllocationPage,
  getClearingStatus,
  getProcessStage,
  putAllocationRemark,
  getAllocationInfo,
  getRemittanceAdvices,
  getInfo,
  putRemittanceAdvices,
  getAllocationInfoPage,
  getCreditNote,
  getCNInfo,
  putCreditNote,
  getPoInfo,
  getIvOtherPayments,
} from "@/api/invoice";
import { removeQuotation } from "@/api/inquiry";
import { updatePiRemark } from "@/api/proforma";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { deepClone } from "@/utils/deepClone";
import {
  uploadDocuments,
} from "@/api/booking-order";
import DeclDocument from "@/views/customs-management/decl-document/DeclDocument.vue";
import {getRAInfo} from "@/api/remittance-advices";
import {Message} from "element-ui";
@Component({
  name: "customerIvManagement",
  components: {
    DeclDocument,
    Pagination,
  },
})
export default class extends Vue {
  private listLoading = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any,
  };
  private listParam = {
    customerId: null,
    codeKeyword: null,
    startDateOfBillOfLoading: null,
    endDateBillOfLoading: null,
    startTimeOfCreated: null,
    endTimeOfCreated: null,
    processStage: null,
    clearingStatus: null,
    clearAmount: false,
  };
  private searchForm = [
    {
      label: "IV号码",
      prop: "codeKeyword",
      key: "codeKeyword",
      type: "input",
      value: "",
      placeholder: "请输入IV号码",
    },
    {
      label: "提单日期",
      prop: "time1",
      key: "time1",
      type: "dateTimePickerGJ",
      // valueFormat: 'yyyy-MM-dd hh:mm:ss',
      placeholder: "请选择提单日期",
      value: "",
    },
    {
      label: "生成日期",
      prop: "time2",
      key: "time2",
      type: "dateTimePickerGJ",
      // valueFormat: 'yyyy-MM-dd hh:mm:ss',
      placeholder: "请选择生成日期",
      value: "",
    },
    {
      label: "报关处理阶段",
      prop: "processStage",
      key: "processStage",
      type: "select",
      value: "",
      options: [],
      placeholder: "请选择",
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "清账状态",
      prop: "clearingStatus",
      key: "clearingStatus",
      type: "select",
      value: "",
      options: [],
      placeholder: "请选择",
      resetKey: { label: "desc", value: "name" },
    },
  ];
  private tableCol = [
    {
      label: "IV号码",
      prop: "ivCode",
      key: "ivCode",
      show: true,
      disabled: false,
    },
    {
      label: "生成日期",
      prop: "ivCreatedTime",
      key: "ivCreatedTime",
      show: true,
      disabled: false,
    },
    {
      label: "提单日期",
      prop: "dateOfBillOfLoading",
      key: "dateOfBillOfLoading",
      show: true,
      disabled: false,
    },
    {
      label: "约定账期",
      prop: "agreedPaymentTerm",
      key: "agreedPaymentTerm",
      show: true,
      disabled: false,
    },
    {
      label: "结期/逾期天数",
      prop: "overdueNumberOfDays",
      key: "overdueNumberOfDays",
      show: true,
      disabled: false,
    },
    {
      label: "报关合同号",
      prop: "bookingOrderCode",
      key: "bookingOrderCode",
      show: true,
      disabled: false,
    },
    {
      label: "报关合同状态",
      prop: "processStage",
      key: "processStage",
      show: true,
      disabled: false,
    },
    {
      label: "IV货款",
      prop: "ivAmountForGoods",
      key: "ivAmountForGoods",
      show: true,
      disabled: false,
    },
    {
      label: " 报关费用",
      prop: "declarationCharge",
      key: "declarationCharge",
      show: true,
      disabled: false,
    },
    {
      label: "其他款项",
      prop: "ivOtherFee",
      key: "ivOtherFee",
      show: true,
      disabled: false,
    },
    {
      label: "IV总金额",
      prop: "ivTotalAmount",
      key: "ivTotalAmount",
      show: true,
      disabled: false,
    },
    {
      label: "CN金额",
      prop: "cnAmount",
      key: "cnAmount",
      show: true,
      disabled: false,
    },
    {
      label: "已分配金额",
      prop: "allocatedAmount",
      key: "allocatedAmount",
      show: true,
      disabled: false,
    },
    {
      label: "剩余未清账",
      prop: "noAllocatedAmount",
      key: "noAllocatedAmount",
      show: true,
      disabled: false,
    },
    {
      label: "收款状态",
      prop: "clearingStatus",
      key: "clearingStatus",
      show: true,
      disabled: false,
      type: "link",
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "清关资料",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "上传文件",
          code: ["upload"],
          click: "uploadDoc",
        },
        {
          name: "下载列表",
          code: ["download"],
          click: "QingGuanZiLiao",
        },
      ],
      show: true,
      disabled: false,
      width: 300,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "查看详情",
          code: "",
          click: "handleToIVM",
        },
        {
          name: "收汇单金额分配",
          code: "",
          click: "handleToSHD",
          key: "clearingStatus",
          value: "未清账,部分分配,已完成"
        },
        {
          name: "绑定CreditNote",
          code: "",
          click: "handleToCN",
        },
        {
          name: "单据流",
          code: "",
          click: "gotoDocumentFlow",
        },
      ],
      show: true,
      disabled: false,
      width: 500,
    },
  ] as any;

  private CollectionFormList = [
    {
      label: "客人简称",
      prop: "customerAbbr",
      key: "customerAbbr",
      type: "input",
      disabled: true,
      placeholder: "请输入客人简称",
      clearable: true,
      maxlength: 100,
    },
    {
      label: "汇款人",
      prop: "paymentName",
      key: "paymentName",
      type: "input",
      disabled: true,
      placeholder: "请输入汇款人",
      clearable: true,
      maxlength: 100,
    },
    {
      label: "货币单位",
      prop: "currency",
      key: "currency",
      type: "input",
      disabled: true,
      placeholder: "请选择货币单位",
      clearable: true,
      maxlength: 100,
    },
    {
      label: "IV号码",
      prop: "ivCode",
      key: "ivCode",
      type: "input",
      disabled: true,
      placeholder: "请输入IV号码",
      clearable: true,
      maxlength: 100,
    },
    {
      label: "IV货款",
      prop: "ivAmountOfGoods",
      key: "ivAmountOfGoods",
      type: "input",
      disabled: true,
      placeholder: "请输入IV货款",
      clearable: true,
      maxlength: 100,
      precision: 2
    },
    {
      label: "收汇单分配金额",
      prop: "allocatedAmount",
      key: "allocatedAmount",
      type: "input",
      disabled: true,
      placeholder: "请输入收汇单分配金额",
      clearable: true,
      maxlength: 100,
      precision: 2
    },
    {
      label: "未结算金额",
      prop: "unAllocatedAmount",
      key: "unAllocatedAmount",
      type: "input",
      disabled: true,
      placeholder: "请输入未结算金额",
      clearable: true,
      maxlength: 100,
      precision: 2
    },
    {
      label: "CN金额",
      prop: "cnAmount",
      key: "cnAmount",
      type: "input",
      disabled: true,
      placeholder: "请输入CN金额",
      clearable: true,
      maxlength: 100,
    },
  ];
  private CollectionForm = { infos: [] } as any;

  private CollectionTableList = [] as any;
  private CollectionTableListCopy = [] as any;
  private CollectionCol = [
    {
      label: "收汇单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false,
    },
    {
      label: "收汇日期",
      prop: "receiptOfAmountDate",
      key: "receiptOfAmountDate",
      show: true,
      disabled: false,
    },
    {
      label: "收汇金额",
      prop: "amountReceived",
      key: "amountReceived",
      show: true,
      disabled: false,
    },
    {
      label: "其他款项",
      prop: "handingFee",
      key: "handingFee",
      show: true,
      disabled: false,
    },
    {
      label: "未分配金额",
      prop: "unAllocatedAmountCopy",
      key: "unAllocatedAmountCopy",
      show: true,
      disabled: false,
    },
    {
      label: "本次分配金额",
      prop: "allocatedAmountOfThis",
      key: "allocatedAmountOfThis",
      show: true,
      type: "inputNumber",
      disabled: false,
      precision: 2,
    },
    {
      label: "收汇单类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
      length: 255,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "移除",
          type: "delete",
          code: "",
          click: "deleteCollection",
        },
      ],
      show: true,
      disabled: false,
      width: 300,
    },
  ];
  private showOne = false;
  private showTwo = false;
  private showThree = false;

  private DetailList = [
    {
      label: "IV总金额",
      prop: "ivTotalAmount",
      key: "ivTotalAmount",
      type: "inputNumber",
      placeholder: "请输入IV总金额",
      clearable: true,
      maxlength: 100,
      disabled: true,
      precision: 2
    },
    {
      label: "IV",
      prop: "ivAmountForGoods",
      key: "ivAmountForGoods",
      type: "inputNumber",
      placeholder: "请输入IV货款",
      clearable: true,
      maxlength: 100,
      disabled: true,
      precision: 2
    },
    {
      label: "额外费用",
      prop: "ivOtherFee",
      key: "ivOtherFee",
      type: "inputNumber",
      placeholder: "请输入额外费用",
      clearable: true,
      maxlength: 100,
      disabled: true,
      precision: 2
    },
  ];
  private DetailForm = {} as any;

  private showAllNumber = false;
  private showOtherAmount = false;

  private DetailCol = [
    {
      label: "Product Name",
      prop: "productName",
      key: "productName",
      show: true,
      disabled: false,
    },
    {
      label: "询价参照号",
      prop: "inquiryRefNumber",
      key: "inquiryRefNumber",
      show: true,
      disabled: false,
    },
    {
      label: "号码类型",
      prop: "inquiryRefType",
      key: "inquiryRefType",
      show: true,
      disabled: false,
    },
    {
      label: "客人号码",
      prop: "customerNumber",
      key: "customerNumber",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "HQ/JR号码",
      prop: "hqNumber",
      key: "hqNumber",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "OE No.",
      prop: "oeNumber",
      key: "oeNumber",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "REF No.",
      prop: "refNumber",
      key: "refNumber",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "QTY",
      prop: "quantity",
      key: "quantity",
      show: true,
      disabled: false,
    },
    {
      label: "UNIT PRICE",
      prop: "saleUnitPrice",
      key: "saleUnitPrice",
      show: true,
      disabled: false,
    },
    {
      label: "TOTAL SUM",
      prop: "TOTALSUM",
      key: "TOTALSUM",
      show: true,
      disabled: false
    },
    {
      label: "PO",
      prop: "poNumber",
      key: "poNumber",
      show: true,
      disabled: false,
    },
    {
      label: "PI",
      prop: "piNumber",
      key: "piNumber",
      show: true,
      disabled: false,
    },
  ];

  private OtherAmountCol = [
    {
      label: "项目",
      prop: "paymentName",
      key: "paymentName",
      show: true,
      disabled: false,
    },
    {
      label: "金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "link",
      show: true,
      disabled: false,
    },
  ];

  private OtherAmountList = [];

  private DetsilTableList = [];

  private CreditNoteTableList = [] as any;
  private CreditNoteTableListCopy = [] as any;

  private CreditNoteCol = [
    {
      label: "CreditNote NO.",
      prop: "code",
      key: "code",
      show: true,
      disabled: false,
    },
    {
      label: "类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false,
    },
    {
      label: "金额",
      prop: "amount",
      key: "amount",
      show: true,
      disabled: false,
    },
    {
      label: "剩余可分配",
      prop: "unAllocatedAmountCopy",
      key: "unAllocatedAmountCopy",
      show: true,
      disabled: false,
      precision: 2,
    },
    {
      label: "本次分配",
      prop: "allocatedAmountOfThis",
      key: "allocatedAmountOfThis",
      type: "inputNumber",
      show: true,
      disabled: false,
      precision: 2,
    },
    {
      label: "原因类型",
      prop: "reason",
      key: "reason",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "移除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 100,
    },
  ];
  private CreditNoteForm = {} as any;

  private CreditNoteFormList = [
    {
      label: "客人简称",
      prop: "customerAbbr",
      key: "customerAbbr",
      type: "input",
      disabled: true,
      placeholder: "请输入客人简称",
      clearable: true,
      maxlength: 100,
    },
    {
      label: "报关合同号",
      prop: "bookingOrderCode",
      key: "bookingOrderCode",
      type: "input",
      disabled: true,
      placeholder: "请输入保管合同号",
      clearable: true,
      maxlength: 100,
    },
    {
      label: "IV号码",
      prop: "ivCode",
      key: "ivCode",
      type: "input",
      disabled: true,
      placeholder: "请输入IV号码",
      clearable: true,
      maxlength: 100,
    },
    {
      label: "合计分配金额",
      prop: "allocatedAmount",
      key: "allocatedAmount",
      type: "input",
      disabled: true,
      placeholder: "请输入合计分配金额",
      clearable: true,
      maxlength: 100,
      precision: 2
    },
    {
      label: "币种",
      prop: "currency",
      key: "currency",
      type: "input",
      disabled: true,
      placeholder: "请选择币种",
      clearable: true,
      maxlength: 100,
    },
  ];

  private addCollectionId = "";
  private addCreditNoteId = "";
  private optionsCollection = [];

  private optionsCreditNote = [];

  private clickROW = { bookingOrderId: "" };
  private files: File[] = [];
  private QingGuanZiLiaoShow = false;
  public diologROW = {} as any;

  private qingGuanlist = [] as any;

  public qingGuanCol = [
    {
      label: "文件名",
      prop: "fileName",
      key: "fileName",
      show: true,
      disabled: false,
      fixed: true,
    },
    {
      label: "上传日期",
      prop: "createdTime",
      key: "createdTime",
      type: "datetime",
      show: true,
      disabled: false,
      fixed: true,
    },
    // {
    //   label: "备注",
    //   prop: "remark",
    //   key: "remark",
    //   type: "remark",
    //   show: true,
    //   disabled: false,
    //   fixed: true
    // }
    {
      label: "操作人",
      prop: "uploader",
      key: "uploader",
      show: true,
      disabled: false,
      fixed: true,
    },
  ];

  private bookingOrderId = 0;

  created() {
    if (this.$route.query.customerId) {
      this.listParam.customerId = this.$route.query.customerId;
    } else {
      this.listParam.customerId = this.$route.params.customerId;
    }
    if (this.$route.params.code) {
      this.listParam.codeKeyword = this.$route.params.code;
      this.listParam.customerId = this.$route.params.customerId;
      this.searchForm[0].value = this.$route.params.code;
    } else {
      this.listParam.codeKeyword = this.$route.query.code;
      this.listParam.customerId = this.$route.query.customerId;
      this.searchForm[0].value = this.$route.query.code as any;
    }
    this.init();
  }

  activated() {
    this.listParam.customerId = this.$route.query.customerId;
    this.init();
  }

  private initSHD() {
    this.addCollectionId = ""; 
    this.CollectionTableList = [] as any;
    this.CollectionTableListCopy = [] as any;
  }

  // IV跳转单据流
  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "IV", documentId: data.row.bookingOrderId },
    });
  }

  private init() {
    this.getProcessStage();
    this.getClearingStatus();
    // this.searchCustomer();
    this.getList();
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = true;
    await getInvoiceSearch(params).then(({ total, content }: any) => {
      this.table.total = +total;
      this.table.list = content;
      this.listLoading = false;
    })
  }
  private isExporting = false;

  private async getProcessStage() {
    const res: any = await getProcessStage();
    this.searchForm[3].options = res;
  }

  private async getClearingStatus() {
    const res: any = await getClearingStatus();
    this.searchForm[4].options = res;
    this.searchForm[4].options.push({
      desc: "全部",
      name: "allStatus",
    });
  }

  private curRowId ="";
  private async QingGuanZiLiao(row) {
    this.QingGuanZiLiaoShow = true;
    this.curRowId = row.row.bookingOrderId;
  }

  private uploadDoc(row) {
    this.$refs["upload"]["$refs"]["upload-inner"].handleClick();
    this.clickROW = row.row;
  }

  private addFile(file: File) {
    // this.files = [file];
    this.files.push(file);
  }

  private async handleUpload() {
    let formData = new window.FormData();
    formData.append("files", this.files.pop());
    this.uploadJieKou(formData);
  }

  private async uploadJieKou(formData) {
    await uploadDocuments(this.clickROW.bookingOrderId, formData);
    this.$notify({
      title: "成功",
      message: "上传成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }
  
  // 导出
  private handleExport() {
    this.isExporting = true;
    let table = this.tableCol.slice(0, this.tableCol.length - 1);
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.table.list);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `客人IV管理-${new Date()}`
    );
    this.isExporting = false;
  }
  //移除
  public handleDelete1(e) {
    const index = e.$index;
    this.CreditNoteTableList.splice(index, 1);
  }

  // 查看详情
  private async handleToIVM(row) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.bookingOrderId = row.row.bookingOrderId;
    await getPoInfo(row.row.bookingOrderId).then((res:any) => {
      this.DetsilTableList = res;
      this.DetsilTableList.map((item) => {
        item.TOTALSUM = (item.quantity * item.saleUnitPrice).toFixed(2);
      });
      this.DetailForm.ivOtherFee = row.row.ivOtherFee;
      this.DetailForm.ivTotalAmount = row.row.ivTotalAmount;
      this.DetailForm.ivAmountForGoods = row.row.ivAmountForGoods;
      this.showThree = true;
      loading.close();
    }).catch(err => {
      console.log(err);
      loading.close();
    });
  }
  // 收汇单信息
  private async handleToSHD(row) {
    this.initSHD();
    this.bookingOrderId = row.row.bookingOrderId;
    const res: any = await getAllocationInfo(row.row.bookingOrderId);
    this.CollectionForm = res;
    if (res.infos && res.infos.length > 0) {
      this.CollectionTableList = res.infos;
      this.CollectionTableList.map((item) => {
        item.unAllocatedAmountCopy = item.unAllocatedAmount;
        item.distributableAmount = Number(
          item.allocatedAmountOfThis + item.unAllocatedAmount
        );
      });
      this.CollectionTableListCopy = JSON.parse(JSON.stringify(res.infos));
      this.CollectionTableListCopy.map((item) => {
        item.unAllocatedAmountCopy = item.unAllocatedAmount;
        item.distributableAmount = Number(
          item.allocatedAmountOfThis + item.unAllocatedAmount
        );
      });
    }
    let params = {
      customerId: res.customerId,
      currency: res.currency,
      ivCode: res.ivCode,
    };
    const data: any = await getRemittanceAdvices(
      row.row.bookingOrderId,
      params
    );
    this.optionsCollection = data.map((item) => {
      return {
        label: item.code + ":" + item.unAllocatedAmount + " " + item.currency,
        value: item.id,
        status: item.optional,
      };
    });
    this.showOne = true;
  }

  private async handleToCN(row) {
    this.initCN();
    this.bookingOrderId = row.row.bookingOrderId;
    const res: any = await getAllocationInfoPage(row.row.bookingOrderId);
    this.CreditNoteForm = res;
    if (res.infos) {
      this.CreditNoteTableList = res.infos;
      this.CreditNoteTableList.map((item) => {
        item.unAllocatedAmountCopy = item.unAllocatedAmount;
        item.distributableAmount = Number(
          item.allocatedAmountOfThis + item.unAllocatedAmount
        );
      });
      this.CreditNoteTableListCopy = JSON.parse(JSON.stringify(res.infos));
    }
    let params = {
      customerId: res.customerId,
      currency: res.currency,
      ivCode: res.ivCode,
    };
    const data: any = await getCreditNote(row.row.bookingOrderId, params);
    this.optionsCreditNote = data.map((item) => {
      return {
        label: item.code + ":" + item.unAllocatedAmount + " " + item.currency,
        value: item.id,
        status: item.optional,
        reason: item.reason,
        remark: item.remark
      };
    });
    this.showTwo = true;
  }

  private async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 填写备注
  private async handleRemark(item) {
    try {
      let data = {
        remark: item.remark,
      };
      let params = {
        clearAmountPage: false
      }
      await putAllocationRemark(item.bookingOrderId, data, params);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }
  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[0].options = res;
  }

  private querySearch(data) {
    const params = Object.assign({}, data);
    const { time1, time2, ...rest } = params;
    if (time1 && time1.length) {
      rest.startDateOfBillOfLoading = time1[0];
      rest.endDateBillOfLoading = time1[1];
    }
    if (time2 && time2.length) {
      rest.startTimeOfCreated = time2[0];
      rest.endTimeOfCreated = time2[1];
    }
    rest.customerId = this.listParam.customerId;
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }
  private async queryDownload(data) {
    const params = Object.assign({}, data);
    const { time1, time2, ...rest } = params;
    if (time1 && time1.length) {
      rest.startDateOfBillOfLoading = time1[0];
      rest.endDateBillOfLoading = time1[1];
    }
    if (time2 && time2.length) {
      rest.startTimeOfCreated = time2[0];
      rest.endTimeOfCreated = time2[1];
    }
    rest.customerId = this.listParam.customerId;
    this.listParam = rest;
    this.table.pageNumber = 1;
    const paramsToHeader = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    await downloadAllocationPage(paramsToHeader);
  }
  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }
  private handleCustomer() {
    console.log(1);
  }

  private async addCollection() {
    if (
      this.CollectionTableList.findIndex(
        (res) => res.id === this.addCollectionId
      ) !== -1
    ) {
      this.$notify({
        title: "提示",
        message: "不能重复选择收汇单",
        type: "error",
        duration: 2000,
      });
      return;
    }
    if (this.addCollectionId === "") {
      this.$notify({
        title: "提示",
        message: "请先选择收汇单",
        type: "error",
        duration: 2000,
      });
      return;
    } else {
      const res: any = await getInfo(this.addCollectionId);
      (res.remark = ""),
        (res.allocatedAmountOfThis = ""),
        (res.unAllocatedAmountCopy = res.unAllocatedAmount);
      res.remittanceAdviceId = this.addCollectionId;
      res.distributableAmount = res.unAllocatedAmount;
      console.log("resresres", res);
      this.CollectionTableList.push(res);
      this.CollectionTableListCopy.push(res);
      console.log("CollectionTableList", this.CollectionTableList);
      console.log("CollectionTableListCopy", this.CollectionTableListCopy);
    }
  }

  private inputChange(e) {
    if (e.column.key === "allocatedAmountOfThis") {
      if (e.val) {
        if (e.val > e.row.row.distributableAmount) {
          this.$notify({
            title: "提示",
            message: "本次分配金额不能大于未分配金额",
            type: "error",
            duration: 2000,
          });
          this.CollectionTableList[
            this.CollectionTableList.findIndex(
              (res) => res.remittanceAdviceId === e.row.row.remittanceAdviceId
            )
          ].allocatedAmountOfThis = 0;
          return;
        } else {
          this.CollectionTableList[
            this.CollectionTableList.findIndex(
              (res) => res.remittanceAdviceId === e.row.row.remittanceAdviceId
            )
          ].unAllocatedAmountCopy = Number(
            e.row.row.distributableAmount - e.val
          ).toFixed(2);
          console.log("11223344", this.CollectionTableList.findIndex(
              (res) => res.remittanceAdviceId === e.row.row.remittanceAdviceId
            ));
        }
      } else {
        this.CollectionTableList[
          this.CollectionTableList.findIndex(
            (res) => res.remittanceAdviceId === e.row.row.remittanceAdviceId
          )
        ].unAllocatedAmountCopy = e.row.row.distributableAmount.toFixed(2);
      }
      this.CollectionForm.allocatedAmount = 0;
      this.CollectionTableList.map((item) => {
        if (item.allocatedAmountOfThis) {
          this.CollectionForm.allocatedAmount += Number(
            item.allocatedAmountOfThis
          );
        }
      });
      // IV货款+CN金额-已分配金额
      this.CollectionForm.unAllocatedAmount = Number(
        this.CollectionForm.ivAmountOfGoods +
          this.CollectionForm.cnAmount  -
          this.CollectionForm.allocatedAmount
      ).toFixed(2);
    }
  }

  /**
   * 收汇单分配的删除操作
   * @param row
   * @private
   */
  private async deleteCollection(row) {
    let remittanceAdviceId = row.row.remittanceAdviceId;
    let data:any = await getRAInfo(remittanceAdviceId);
    if (data.state === 'ALL') {
      Message.error({
        message:"该收汇单已经完全分配，无法进行移除操作",
        duration: 2000
      })
      return;
    }
    this.CollectionTableList =  this.CollectionTableList.filter(item =>  item.remittanceAdviceId !== remittanceAdviceId);
  }


  private async showOneConfirm() {
    this.$confirm("收汇单金额一旦被完全分配，状态流转为完成分配，则不能变更及删除金额。", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        let infos = this.CollectionTableList.map((item) => {
          return {
            id: item.allocatedInfoId ? item.allocatedInfoId : "",
            remittanceAdviceId: item.remittanceAdviceId
              ? item.remittanceAdviceId
              : "",
            amount: item.allocatedAmountOfThis,
          };
        });
        await putRemittanceAdvices(this.bookingOrderId, { infos })
          .then((res) => {
            this.showOne = false;
            this.$notify({
              title: "提示",
              message: "收汇单金额分配成功",
              type: "success",
              duration: 2000,
            });
            this.getList();
            this.initSHD();
          })
          .catch((err) => {
            console.log("err", err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async addCreditNote() {
    if (
      this.CreditNoteTableList.findIndex(
        (res) => res.id === this.addCreditNoteId
      ) !== -1
    ) {
      this.$notify({
        title: "提示",
        message: "不能重复选择CreditNote",
        type: "error",
        duration: 2000,
      });
      return;
    }
    if (this.addCreditNoteId === "") {
      this.$notify({
        title: "提示",
        message: "请先选择CreditNote",
        type: "error",
        duration: 2000,
      });
      return;
    } else {
      const res: any = await getCNInfo(this.addCreditNoteId);
      res.unAllocatedAmountCopy = res.unAllocatedAmount;
      res.addCreditNoteId = this.addCreditNoteId;
      res.distributableAmount = res.unAllocatedAmount;
      this.CreditNoteTableList.push(res);
      this.CreditNoteTableListCopy.push(res);
    }
  }

  private inputChangeCN(e) {
    if (e.column.key === "allocatedAmountOfThis") {
      if (e.val) {
        if (e.val > e.row.row.distributableAmount) {
          this.$notify({
            title: "提示",
            message: "本次分配金额不能大于未分配金额",
            type: "error",
            duration: 2000,
          });
          this.CreditNoteTableList[
            this.CreditNoteTableList.findIndex((res) => res.id === e.row.row.id)
          ].allocatedAmountOfThis = 0;
          return;
        } else {
          this.CreditNoteTableList[
            this.CreditNoteTableList.findIndex((res) => res.id === e.row.row.id)
          ].unAllocatedAmountCopy = Number(
            e.row.row.distributableAmount - e.val
          ).toFixed(2);
        }
      } else {
        this.CreditNoteTableList[
          this.CreditNoteTableList.findIndex((res) => res.id === e.row.row.id)
        ].unAllocatedAmountCopy = e.row.row.distributableAmount.toFixed(2);
      }
      this.CreditNoteForm.allocatedAmount = 0;
      this.CreditNoteTableList.map((item) => {
        if (item.allocatedAmountOfThis) {
          // cn 负数计算，dn 正数计算。
          let amount = item.type === 'CreditNote' ? -Number(
                  item.allocatedAmountOfThis
              ) : Number(item.allocatedAmountOfThis);
          this.CreditNoteForm.allocatedAmount += amount;
        }
      });
    }
  }

  private async showTwoConfirm() {
    this.$confirm("CN金额一旦被完全分配，状态流转为完成分配，则不能变更及删除金额。", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        let infos = this.CreditNoteTableList.map((item) => {
          return {
            id: item.allocationInfoId ? item.allocationInfoId : "",
            creditNoteId: item.addCreditNoteId
              ? item.addCreditNoteId
              : item.creditNoteId,
            amount: item.allocatedAmountOfThis,
          };
        });
        await putCreditNote(this.bookingOrderId, { infos })
          .then((res) => {
            this.showTwo = false;
            this.$notify({
              title: "提示",
              message: "绑定CreditNote成功",
              type: "success",
              duration: 2000,
            });
            this.getList();
            this.initCN();
          })
          .catch((err) => {
            console.log("err", err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private initCN() {
    this.addCreditNoteId = "";
    this.CreditNoteTableList = [] as any;
    this.CreditNoteTableListCopy = [] as any;
  }

  private exportDetsilTableList() {
    this.isExporting = true;
    let table = this.DetailCol;
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.DetsilTableList);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `IV详情-${new Date()}`
    );
    this.isExporting = false;
  }

  private async showOtherAmountFun() {
    const res: any = await getIvOtherPayments(this.bookingOrderId);
    this.OtherAmountList = res;
    this.showOtherAmount = true;
  }

  private exportOtherAmount() {
    this.isExporting = true;
    let table = this.OtherAmountCol;
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.OtherAmountList);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `其他款项-${new Date()}`
    );
    this.isExporting = false;
  }
}
